// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__Ythlc","unreadBadge":"styles_unreadBadge__17ank","modalContent":"styles_modalContent__sx3LE","modal":"styles_modal__1Q8UI"};